import Vue from 'vue'

import configuration from "@/core/api/configuration.serve"
import manage from "@/core/api/manage.serve"//管理的接口的
import system from "@/core/api/system.serve"//公用
import author from "@/core/api/author.serve"//作者
import contributionManagement from "@/core/api/contributionManagement.serve"//稿件管理


const apis={
	configuration,
  manage,
  system,
  author,
  contributionManagement,
}
export default {
  install() {
    Vue.prototype.$apis = apis
  }
}



// WEBPACK FOOTER //
// ./src/core/api/config/index.js